import { SvelteComponent, init, safe_not_equal, element, space, text, attr, insert, append, listen, prevent_default, detach, empty, noop, is_function } from '../../../../external_node_modules/svelte/internal/index.mjs.js';
import { t } from '../../../../i18n.js';
import './AdditionalProductTile.css.js';

/* src/ui/FastGold/components/AdditionalProductTile/AdditionalProductTile.svelte generated by Svelte v3.44.2 */

function create_if_block(ctx) {
	let div6;
	let div5;
	let div1;
	let div0;
	let t1;
	let div2;
	let t2;
	let div4;
	let div3;
	let span;
	let t3_value = t('Перейти к витрине') + "";
	let t3;
	let mounted;
	let dispose;

	return {
		c() {
			div6 = element("div");
			div5 = element("div");
			div1 = element("div");
			div0 = element("div");
			div0.textContent = `${t('Больше наборов')}`;
			t1 = space();
			div2 = element("div");
			t2 = space();
			div4 = element("div");
			div3 = element("div");
			span = element("span");
			t3 = text(t3_value);
			attr(div0, "class", "tile-top-title wcl-63hr4a");
			attr(div1, "class", "tile-top wcl-63hr4a");
			attr(div2, "class", "tile-center wcl-63hr4a");
			attr(span, "class", "doubloons-icon wcl-63hr4a");
			attr(div3, "class", "tile-bottom-description wcl-63hr4a");
			attr(div4, "class", "tile-bottom wcl-63hr4a");
			attr(div5, "class", "tile-container wcl-63hr4a");
			attr(div6, "class", "tile tile14 wcl-63hr4a");
		},
		m(target, anchor) {
			insert(target, div6, anchor);
			append(div6, div5);
			append(div5, div1);
			append(div1, div0);
			append(div5, t1);
			append(div5, div2);
			append(div5, t2);
			append(div5, div4);
			append(div4, div3);
			append(div3, span);
			append(div3, t3);

			if (!mounted) {
				dispose = listen(div5, "mousedown", prevent_default(function () {
					if (is_function(/*onOpenMoreBundles*/ ctx[0])) /*onOpenMoreBundles*/ ctx[0].apply(this, arguments);
				}));

				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
		},
		d(detaching) {
			if (detaching) detach(div6);
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;
	let if_block = /*onOpenMoreBundles*/ ctx[0] && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, [dirty]) {
			if (/*onOpenMoreBundles*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { onOpenMoreBundles } = $$props;

	$$self.$$set = $$props => {
		if ('onOpenMoreBundles' in $$props) $$invalidate(0, onOpenMoreBundles = $$props.onOpenMoreBundles);
	};

	return [onOpenMoreBundles];
}

class AdditionalProductTile extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { onOpenMoreBundles: 0 });
	}
}

export { AdditionalProductTile as default };
//# sourceMappingURL=AdditionalProductTile.svelte.js.map
